import "../styles/not-found.css";

export default function NotFoundPage() {
  return (
    <main className="not-found">
      <a className="wordmark" href="/" aria-label="Ebrahim Ahmadivarzaneh, home">EA<span>/</span></a>
      <p className="not-found-code">404 · Page not found</p>
      <h1>This page isn’t here anymore.</h1>
      <p>The link may be out of date, or the address may be incorrect. You can find my current services on the homepage.</p>
      <div className="not-found-links">
        <a href="/">Back to homepage</a>
        <a href="/#contact">Get in touch</a>
      </div>
    </main>
  );
}
